import BG from '~/components/background';
import davichi01 from "../../../../src/events/2021/03/event-davichi/images/0001.jpg";
import davichi02 from "../../../../src/events/2021/03/event-davichi/images/0002.jpg";
import davichi03 from "../../../../src/events/2021/03/event-davichi/images/0003.jpg";
import davichi04 from "../../../../src/events/2021/03/event-davichi/images/0004.jpg";
import davichi05 from "../../../../src/events/2021/03/event-davichi/images/0005.jpg";
import davichi06 from "../../../../src/events/2021/03/event-davichi/images/0006.jpg";
import davichi07 from "../../../../src/events/2021/03/event-davichi/images/0007.jpg";
import davichi08 from "../../../../src/events/2021/03/event-davichi/images/0008.jpg";
import davichi09 from "../../../../src/events/2021/03/event-davichi/images/0009.jpg";
import * as React from 'react';
export default {
  BG,
  davichi01,
  davichi02,
  davichi03,
  davichi04,
  davichi05,
  davichi06,
  davichi07,
  davichi08,
  davichi09,
  React
};